const _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : {};

const host =
  _window.location && _window.location.host
    ? _window.location.host
    : 'www.wix.com';
const location = _window.__LOCATION__ || {};
const locale = _window.__LOCALE__ || 'en';
const initialI18n = _window.__INITIAL_I18N__ || {};
const baseURL = _window.__BASEURL__ || '/marketplace/';
const isInternal = _window.__IS_INTERNAL__ || false;
const userAgent = _window.navigator ? _window.navigator.userAgent : '';

module.exports = {
  host,
  location,
  locale,
  initialI18n,
  baseURL,
  isInternal,
  userAgent,
};
